export default async ({ store, redirect }) => {
  const { currentSpace } = store.state.space;
  if (!currentSpace.id || !currentSpace.isActiveCoachRoom) {
    return redirect(`/space/${currentSpace.id}`);
  }
};
